// extracted by mini-css-extract-plugin
module.exports = {"flex-column-center":"CustomPricingPackageDialog_flex-column-center__-XEid","flex-column-start":"CustomPricingPackageDialog_flex-column-start__Gq9aI"};